import { tokens } from "../theme";

export const mockDataTeam = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    access: "admin",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    access: "manager",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    access: "user",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    access: "admin",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    access: "user",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    access: "manager",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    access: "user",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    access: "user",
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    access: "admin",
  },
];

export const mockDataContacts = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    age: 35,
    phone: "(665)121-5454",
    address: "0912 Won Street, Alabama, SY 10001",
    city: "New York",
    zipCode: "10001",
    registrarId: 123512,
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    age: 42,
    phone: "(421)314-2288",
    address: "1234 Main Street, New York, NY 10001",
    city: "New York",
    zipCode: "13151",
    registrarId: 123512,
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    age: 45,
    phone: "(422)982-6739",
    address: "3333 Want Blvd, Estanza, NAY 42125",
    city: "New York",
    zipCode: "87281",
    registrarId: 4132513,
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    age: 16,
    phone: "(921)425-6742",
    address: "1514 Main Street, New York, NY 22298",
    city: "New York",
    zipCode: "15551",
    registrarId: 123512,
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    age: 31,
    phone: "(421)445-1189",
    address: "11122 Welping Ave, Tenting, CD 21321",
    city: "Tenting",
    zipCode: "14215",
    registrarId: 123512,
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    age: 150,
    phone: "(232)545-6483",
    address: "1234 Canvile Street, Esvazark, NY 10001",
    city: "Esvazark",
    zipCode: "10001",
    registrarId: 123512,
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    age: 44,
    phone: "(543)124-0123",
    address: "22215 Super Street, Everting, ZO 515234",
    city: "Evertin",
    zipCode: "51523",
    registrarId: 123512,
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    age: 36,
    phone: "(222)444-5555",
    address: "4123 Ever Blvd, Wentington, AD 142213",
    city: "Esteras",
    zipCode: "44215",
    registrarId: 512315,
  },
  {
    id: 9,
    name: "Harvey Roxie",
    email: "harveyroxie@gmail.com",
    age: 65,
    phone: "(444)555-6239",
    address: "51234 Avery Street, Cantory, ND 212412",
    city: "Colunza",
    zipCode: "111234",
    registrarId: 928397,
  },
  {
    id: 10,
    name: "Enteri Redack",
    email: "enteriredack@gmail.com",
    age: 42,
    phone: "(222)444-5555",
    address: "4123 Easer Blvd, Wentington, AD 142213",
    city: "Esteras",
    zipCode: "44215",
    registrarId: 533215,
  },
  {
    id: 11,
    name: "Steve Goodman",
    email: "stevegoodmane@gmail.com",
    age: 11,
    phone: "(444)555-6239",
    address: "51234 Fiveton Street, CunFory, ND 212412",
    city: "Colunza",
    zipCode: "1234",
    registrarId: 92197,
  },
];

export const mockDataInvoices = [
  {
    id: 1,
    name: "Jon Snow",
    email: "jonsnow@gmail.com",
    cost: "21.24",
    phone: "(665)121-5454",
    date: "03/12/2022",
  },
  {
    id: 2,
    name: "Cersei Lannister",
    email: "cerseilannister@gmail.com",
    cost: "1.24",
    phone: "(421)314-2288",
    date: "06/15/2021",
  },
  {
    id: 3,
    name: "Jaime Lannister",
    email: "jaimelannister@gmail.com",
    cost: "11.24",
    phone: "(422)982-6739",
    date: "05/02/2022",
  },
  {
    id: 4,
    name: "Anya Stark",
    email: "anyastark@gmail.com",
    cost: "80.55",
    phone: "(921)425-6742",
    date: "03/21/2022",
  },
  {
    id: 5,
    name: "Daenerys Targaryen",
    email: "daenerystargaryen@gmail.com",
    cost: "1.24",
    phone: "(421)445-1189",
    date: "01/12/2021",
  },
  {
    id: 6,
    name: "Ever Melisandre",
    email: "evermelisandre@gmail.com",
    cost: "63.12",
    phone: "(232)545-6483",
    date: "11/02/2022",
  },
  {
    id: 7,
    name: "Ferrara Clifford",
    email: "ferraraclifford@gmail.com",
    cost: "52.42",
    phone: "(543)124-0123",
    date: "02/11/2022",
  },
  {
    id: 8,
    name: "Rossini Frances",
    email: "rossinifrances@gmail.com",
    cost: "21.24",
    phone: "(222)444-5555",
    date: "05/02/2021",
  },
];

export const mockTransactions = [
  {
    txId: "01e4dsa",
    user: "johndoe",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.45",
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "51034szv",
    user: "goodmanave",
    date: "2022-11-05",
    cost: "200.95",
  },
  {
    txId: "0a123sb",
    user: "stevebower",
    date: "2022-11-02",
    cost: "13.55",
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "43.95",
  },
  {
    txId: "120s51a",
    user: "wootzifer",
    date: "2019-04-15",
    cost: "24.20",
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133.45",
  },
];

export const mockBarData = [
  {
    country: "AD",
    "hot dog": 137,
    "hot dogColor": "hsl(229, 70%, 50%)",
    burger: 96,
    burgerColor: "hsl(296, 70%, 50%)",
    kebab: 72,
    kebabColor: "hsl(97, 70%, 50%)",
    donut: 140,
    donutColor: "hsl(340, 70%, 50%)",
  },
  {
    country: "AE",
    "hot dog": 55,
    "hot dogColor": "hsl(307, 70%, 50%)",
    burger: 28,
    burgerColor: "hsl(111, 70%, 50%)",
    kebab: 58,
    kebabColor: "hsl(273, 70%, 50%)",
    donut: 29,
    donutColor: "hsl(275, 70%, 50%)",
  },
  {
    country: "AF",
    "hot dog": 109,
    "hot dogColor": "hsl(72, 70%, 50%)",
    burger: 23,
    burgerColor: "hsl(96, 70%, 50%)",
    kebab: 34,
    kebabColor: "hsl(106, 70%, 50%)",
    donut: 152,
    donutColor: "hsl(256, 70%, 50%)",
  },
  {
    country: "AG",
    "hot dog": 133,
    "hot dogColor": "hsl(257, 70%, 50%)",
    burger: 52,
    burgerColor: "hsl(326, 70%, 50%)",
    kebab: 43,
    kebabColor: "hsl(110, 70%, 50%)",
    donut: 83,
    donutColor: "hsl(9, 70%, 50%)",
  },
  {
    country: "AI",
    "hot dog": 81,
    "hot dogColor": "hsl(190, 70%, 50%)",
    burger: 80,
    burgerColor: "hsl(325, 70%, 50%)",
    kebab: 112,
    kebabColor: "hsl(54, 70%, 50%)",
    donut: 35,
    donutColor: "hsl(285, 70%, 50%)",
  },
  {
    country: "AL",
    "hot dog": 66,
    "hot dogColor": "hsl(208, 70%, 50%)",
    burger: 111,
    burgerColor: "hsl(334, 70%, 50%)",
    kebab: 167,
    kebabColor: "hsl(182, 70%, 50%)",
    donut: 18,
    donutColor: "hsl(76, 70%, 50%)",
  },
  {
    country: "AM",
    "hot dog": 80,
    "hot dogColor": "hsl(87, 70%, 50%)",
    burger: 47,
    burgerColor: "hsl(141, 70%, 50%)",
    kebab: 158,
    kebabColor: "hsl(224, 70%, 50%)",
    donut: 49,
    donutColor: "hsl(274, 70%, 50%)",
  },
];

export const mockPieData = [
  {
    id: "hack",
    label: "hack",
    value: 239,
    color: "hsl(104, 70%, 50%)",
  },
  {
    id: "make",
    label: "make",
    value: 170,
    color: "hsl(162, 70%, 50%)",
  },
  {
    id: "go",
    label: "go",
    value: 322,
    color: "hsl(291, 70%, 50%)",
  },
  {
    id: "lisp",
    label: "lisp",
    value: 503,
    color: "hsl(229, 70%, 50%)",
  },
  {
    id: "scala",
    label: "scala",
    value: 584,
    color: "hsl(344, 70%, 50%)",
  },
];

export const mockLineData = [
  {
    id: "japan",
    color: tokens("dark").greenAccent[500],
    data: [
      {
        x: "plane",
        y: 101,
      },
      {
        x: "helicopter",
        y: 75,
      },
      {
        x: "boat",
        y: 36,
      },
      {
        x: "train",
        y: 216,
      },
      {
        x: "subway",
        y: 35,
      },
      {
        x: "bus",
        y: 236,
      },
      {
        x: "car",
        y: 88,
      },
      {
        x: "moto",
        y: 232,
      },
      {
        x: "bicycle",
        y: 281,
      },
      {
        x: "horse",
        y: 1,
      },
      {
        x: "skateboard",
        y: 35,
      },
      {
        x: "others",
        y: 14,
      },
    ],
  },
  {
    id: "france",
    color: tokens("dark").blueAccent[300],
    data: [
      {
        x: "plane",
        y: 212,
      },
      {
        x: "helicopter",
        y: 190,
      },
      {
        x: "boat",
        y: 270,
      },
      {
        x: "train",
        y: 9,
      },
      {
        x: "subway",
        y: 75,
      },
      {
        x: "bus",
        y: 175,
      },
      {
        x: "car",
        y: 33,
      },
      {
        x: "moto",
        y: 189,
      },
      {
        x: "bicycle",
        y: 97,
      },
      {
        x: "horse",
        y: 87,
      },
      {
        x: "skateboard",
        y: 299,
      },
      {
        x: "others",
        y: 251,
      },
    ],
  },
  {
    id: "us",
    color: tokens("dark").redAccent[200],
    data: [
      {
        x: "plane",
        y: 191,
      },
      {
        x: "helicopter",
        y: 136,
      },
      {
        x: "boat",
        y: 91,
      },
      {
        x: "train",
        y: 190,
      },
      {
        x: "subway",
        y: 211,
      },
      {
        x: "bus",
        y: 152,
      },
      {
        x: "car",
        y: 189,
      },
      {
        x: "moto",
        y: 152,
      },
      {
        x: "bicycle",
        y: 8,
      },
      {
        x: "horse",
        y: 197,
      },
      {
        x: "skateboard",
        y: 107,
      },
      {
        x: "others",
        y: 170,
      },
    ],
  },
];

export const mockGeographyData = [
  {
    id: "AFG",
    value: 520600,
  },
  {
    id: "AGO",
    value: 949905,
  },
  {
    id: "ALB",
    value: 329910,
  },
  {
    id: "ARE",
    value: 675484,
  },
  {
    id: "ARG",
    value: 432239,
  },
  {
    id: "ARM",
    value: 288305,
  },
  {
    id: "ATA",
    value: 415648,
  },
  {
    id: "ATF",
    value: 665159,
  },
  {
    id: "AUT",
    value: 798526,
  },
  {
    id: "AZE",
    value: 481678,
  },
  {
    id: "BDI",
    value: 496457,
  },
  {
    id: "BEL",
    value: 252276,
  },
  {
    id: "BEN",
    value: 440315,
  },
  {
    id: "BFA",
    value: 343752,
  },
  {
    id: "BGD",
    value: 920203,
  },
  {
    id: "BGR",
    value: 261196,
  },
  {
    id: "BHS",
    value: 421551,
  },
  {
    id: "BIH",
    value: 974745,
  },
  {
    id: "BLR",
    value: 349288,
  },
  {
    id: "BLZ",
    value: 305983,
  },
  {
    id: "BOL",
    value: 430840,
  },
  {
    id: "BRN",
    value: 345666,
  },
  {
    id: "BTN",
    value: 649678,
  },
  {
    id: "BWA",
    value: 319392,
  },
  {
    id: "CAF",
    value: 722549,
  },
  {
    id: "CAN",
    value: 332843,
  },
  {
    id: "CHE",
    value: 122159,
  },
  {
    id: "CHL",
    value: 811736,
  },
  {
    id: "CHN",
    value: 593604,
  },
  {
    id: "CIV",
    value: 143219,
  },
  {
    id: "CMR",
    value: 630627,
  },
  {
    id: "COG",
    value: 498556,
  },
  {
    id: "COL",
    value: 660527,
  },
  {
    id: "CRI",
    value: 60262,
  },
  {
    id: "CUB",
    value: 177870,
  },
  {
    id: "-99",
    value: 463208,
  },
  {
    id: "CYP",
    value: 945909,
  },
  {
    id: "CZE",
    value: 500109,
  },
  {
    id: "DEU",
    value: 63345,
  },
  {
    id: "DJI",
    value: 634523,
  },
  {
    id: "DNK",
    value: 731068,
  },
  {
    id: "DOM",
    value: 262538,
  },
  {
    id: "DZA",
    value: 760695,
  },
  {
    id: "ECU",
    value: 301263,
  },
  {
    id: "EGY",
    value: 148475,
  },
  {
    id: "ERI",
    value: 939504,
  },
  {
    id: "ESP",
    value: 706050,
  },
  {
    id: "EST",
    value: 977015,
  },
  {
    id: "ETH",
    value: 461734,
  },
  {
    id: "FIN",
    value: 22800,
  },
  {
    id: "FJI",
    value: 18985,
  },
  {
    id: "FLK",
    value: 64986,
  },
  {
    id: "FRA",
    value: 447457,
  },
  {
    id: "GAB",
    value: 669675,
  },
  {
    id: "GBR",
    value: 757120,
  },
  {
    id: "GEO",
    value: 158702,
  },
  {
    id: "GHA",
    value: 893180,
  },
  {
    id: "GIN",
    value: 877288,
  },
  {
    id: "GMB",
    value: 724530,
  },
  {
    id: "GNB",
    value: 387753,
  },
  {
    id: "GNQ",
    value: 706118,
  },
  {
    id: "GRC",
    value: 377796,
  },
  {
    id: "GTM",
    value: 66890,
  },
  {
    id: "GUY",
    value: 719300,
  },
  {
    id: "HND",
    value: 739590,
  },
  {
    id: "HRV",
    value: 929467,
  },
  {
    id: "HTI",
    value: 538961,
  },
  {
    id: "HUN",
    value: 146095,
  },
  {
    id: "IDN",
    value: 490681,
  },
  {
    id: "IND",
    value: 549818,
  },
  {
    id: "IRL",
    value: 630163,
  },
  {
    id: "IRN",
    value: 596921,
  },
  {
    id: "IRQ",
    value: 767023,
  },
  {
    id: "ISL",
    value: 478682,
  },
  {
    id: "ISR",
    value: 963688,
  },
  {
    id: "ITA",
    value: 393089,
  },
  {
    id: "JAM",
    value: 83173,
  },
  {
    id: "JOR",
    value: 52005,
  },
  {
    id: "JPN",
    value: 199174,
  },
  {
    id: "KAZ",
    value: 181424,
  },
  {
    id: "KEN",
    value: 60946,
  },
  {
    id: "KGZ",
    value: 432478,
  },
  {
    id: "KHM",
    value: 254461,
  },
  {
    id: "OSA",
    value: 942447,
  },
  {
    id: "KWT",
    value: 414413,
  },
  {
    id: "LAO",
    value: 448339,
  },
  {
    id: "LBN",
    value: 620090,
  },
  {
    id: "LBR",
    value: 435950,
  },
  {
    id: "LBY",
    value: 75091,
  },
  {
    id: "LKA",
    value: 595124,
  },
  {
    id: "LSO",
    value: 483524,
  },
  {
    id: "LTU",
    value: 867357,
  },
  {
    id: "LUX",
    value: 689172,
  },
  {
    id: "LVA",
    value: 742980,
  },
  {
    id: "MAR",
    value: 236538,
  },
  {
    id: "MDA",
    value: 926836,
  },
  {
    id: "MDG",
    value: 840840,
  },
  {
    id: "MEX",
    value: 353910,
  },
  {
    id: "MKD",
    value: 505842,
  },
  {
    id: "MLI",
    value: 286082,
  },
  {
    id: "MMR",
    value: 915544,
  },
  {
    id: "MNE",
    value: 609500,
  },
  {
    id: "MNG",
    value: 410428,
  },
  {
    id: "MOZ",
    value: 32868,
  },
  {
    id: "MRT",
    value: 375671,
  },
  {
    id: "MWI",
    value: 591935,
  },
  {
    id: "MYS",
    value: 991644,
  },
  {
    id: "NAM",
    value: 701897,
  },
  {
    id: "NCL",
    value: 144098,
  },
  {
    id: "NER",
    value: 312944,
  },
  {
    id: "NGA",
    value: 862877,
  },
  {
    id: "NIC",
    value: 90831,
  },
  {
    id: "NLD",
    value: 281879,
  },
  {
    id: "NOR",
    value: 224537,
  },
  {
    id: "NPL",
    value: 322331,
  },
  {
    id: "NZL",
    value: 86615,
  },
  {
    id: "OMN",
    value: 707881,
  },
  {
    id: "PAK",
    value: 158577,
  },
  {
    id: "PAN",
    value: 738579,
  },
  {
    id: "PER",
    value: 248751,
  },
  {
    id: "PHL",
    value: 557292,
  },
  {
    id: "PNG",
    value: 516874,
  },
  {
    id: "POL",
    value: 682137,
  },
  {
    id: "PRI",
    value: 957399,
  },
  {
    id: "PRT",
    value: 846430,
  },
  {
    id: "PRY",
    value: 720555,
  },
  {
    id: "QAT",
    value: 478726,
  },
  {
    id: "ROU",
    value: 259318,
  },
  {
    id: "RUS",
    value: 268735,
  },
  {
    id: "RWA",
    value: 136781,
  },
  {
    id: "ESH",
    value: 151957,
  },
  {
    id: "SAU",
    value: 111821,
  },
  {
    id: "SDN",
    value: 927112,
  },
  {
    id: "SDS",
    value: 966473,
  },
  {
    id: "SEN",
    value: 158085,
  },
  {
    id: "SLB",
    value: 178389,
  },
  {
    id: "SLE",
    value: 528433,
  },
  {
    id: "SLV",
    value: 353467,
  },
  {
    id: "ABV",
    value: 251,
  },
  {
    id: "SOM",
    value: 445243,
  },
  {
    id: "SRB",
    value: 202402,
  },
  {
    id: "SUR",
    value: 972121,
  },
  {
    id: "SVK",
    value: 319923,
  },
  {
    id: "SVN",
    value: 728766,
  },
  {
    id: "SWZ",
    value: 379669,
  },
  {
    id: "SYR",
    value: 16221,
  },
  {
    id: "TCD",
    value: 101273,
  },
  {
    id: "TGO",
    value: 498411,
  },
  {
    id: "THA",
    value: 506906,
  },
  {
    id: "TJK",
    value: 613093,
  },
  {
    id: "TKM",
    value: 327016,
  },
  {
    id: "TLS",
    value: 607972,
  },
  {
    id: "TTO",
    value: 936365,
  },
  {
    id: "TUN",
    value: 898416,
  },
  {
    id: "TUR",
    value: 237783,
  },
  {
    id: "TWN",
    value: 878213,
  },
  {
    id: "TZA",
    value: 442174,
  },
  {
    id: "UGA",
    value: 720710,
  },
  {
    id: "UKR",
    value: 74172,
  },
  {
    id: "URY",
    value: 753177,
  },
  {
    id: "USA",
    value: 658725,
  },
  {
    id: "UZB",
    value: 550313,
  },
  {
    id: "VEN",
    value: 707492,
  },
  {
    id: "VNM",
    value: 538907,
  },
  {
    id: "VUT",
    value: 650646,
  },
  {
    id: "PSE",
    value: 476078,
  },
  {
    id: "YEM",
    value: 957751,
  },
  {
    id: "ZAF",
    value: 836949,
  },
  {
    id: "ZMB",
    value: 714503,
  },
  {
    id: "ZWE",
    value: 405217,
  },
  {
    id: "KOR",
    value: 171135,
  },
];

export const countryData = [
  { name: "Afghanistan", "alpha-3": "AFG", "country-code": "004" },
  { name: "Åland Islands", "alpha-3": "ALA", "country-code": "248" },
  { name: "Albania", "alpha-3": "ALB", "country-code": "008" },
  { name: "Algeria", "alpha-3": "DZA", "country-code": "012" },
  { name: "American Samoa", "alpha-3": "ASM", "country-code": "016" },
  { name: "Andorra", "alpha-3": "AND", "country-code": "020" },
  { name: "Angola", "alpha-3": "AGO", "country-code": "024" },
  { name: "Anguilla", "alpha-3": "AIA", "country-code": "660" },
  { name: "Antarctica", "alpha-3": "ATA", "country-code": "010" },
  { name: "Antigua and Barbuda", "alpha-3": "ATG", "country-code": "028" },
  { name: "Argentina", "alpha-3": "ARG", "country-code": "032" },
  { name: "Armenia", "alpha-3": "ARM", "country-code": "051" },
  { name: "Aruba", "alpha-3": "ABW", "country-code": "533" },
  { name: "Australia", "alpha-3": "AUS", "country-code": "036" },
  { name: "Austria", "alpha-3": "AUT", "country-code": "040" },
  { name: "Azerbaijan", "alpha-3": "AZE", "country-code": "031" },
  { name: "Bahamas", "alpha-3": "BHS", "country-code": "044" },
  { name: "Bahrain", "alpha-3": "BHR", "country-code": "048" },
  { name: "Bangladesh", "alpha-3": "BGD", "country-code": "050" },
  { name: "Barbados", "alpha-3": "BRB", "country-code": "052" },
  { name: "Belarus", "alpha-3": "BLR", "country-code": "112" },
  { name: "Belgium", "alpha-3": "BEL", "country-code": "056" },
  { name: "Belize", "alpha-3": "BLZ", "country-code": "084" },
  { name: "Benin", "alpha-3": "BEN", "country-code": "204" },
  { name: "Bermuda", "alpha-3": "BMU", "country-code": "060" },
  { name: "Bhutan", "alpha-3": "BTN", "country-code": "064" },
  {
    name: "Bolivia (Plurinational State of)",
    "alpha-3": "BOL",
    "country-code": "068",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    "alpha-3": "BES",
    "country-code": "535",
  },
  { name: "Bosnia and Herzegovina", "alpha-3": "BIH", "country-code": "070" },
  { name: "Botswana", "alpha-3": "BWA", "country-code": "072" },
  { name: "Bouvet Island", "alpha-3": "BVT", "country-code": "074" },
  { name: "Brazil", "alpha-3": "BRA", "country-code": "076" },
  {
    name: "British Indian Ocean Territory",
    "alpha-3": "IOT",
    "country-code": "086",
  },
  { name: "Brunei Darussalam", "alpha-3": "BRN", "country-code": "096" },
  { name: "Bulgaria", "alpha-3": "BGR", "country-code": "100" },
  { name: "Burkina Faso", "alpha-3": "BFA", "country-code": "854" },
  { name: "Burundi", "alpha-3": "BDI", "country-code": "108" },
  { name: "Cabo Verde", "alpha-3": "CPV", "country-code": "132" },
  { name: "Cambodia", "alpha-3": "KHM", "country-code": "116" },
  { name: "Cameroon", "alpha-3": "CMR", "country-code": "120" },
  { name: "Canada", "alpha-3": "CAN", "country-code": "124" },
  { name: "Cayman Islands", "alpha-3": "CYM", "country-code": "136" },
  { name: "Central African Republic", "alpha-3": "CAF", "country-code": "140" },
  { name: "Chad", "alpha-3": "TCD", "country-code": "148" },
  { name: "Chile", "alpha-3": "CHL", "country-code": "152" },
  { name: "China", "alpha-3": "CHN", "country-code": "156" },
  { name: "Christmas Island", "alpha-3": "CXR", "country-code": "162" },
  { name: "Cocos (Keeling) Islands", "alpha-3": "CCK", "country-code": "166" },
  { name: "Colombia", "alpha-3": "COL", "country-code": "170" },
  { name: "Comoros", "alpha-3": "COM", "country-code": "174" },
  { name: "Congo", "alpha-3": "COG", "country-code": "178" },
  {
    name: "Congo, Democratic Republic of the",
    "alpha-3": "COD",
    "country-code": "180",
  },
  { name: "Cook Islands", "alpha-3": "COK", "country-code": "184" },
  { name: "Costa Rica", "alpha-3": "CRI", "country-code": "188" },
  { name: "Côte d'Ivoire", "alpha-3": "CIV", "country-code": "384" },
  { name: "Croatia", "alpha-3": "HRV", "country-code": "191" },
  { name: "Cuba", "alpha-3": "CUB", "country-code": "192" },
  { name: "Curaçao", "alpha-3": "CUW", "country-code": "531" },
  { name: "Cyprus", "alpha-3": "CYP", "country-code": "196" },
  { name: "Czechia", "alpha-3": "CZE", "country-code": "203" },
  { name: "Denmark", "alpha-3": "DNK", "country-code": "208" },
  { name: "Djibouti", "alpha-3": "DJI", "country-code": "262" },
  { name: "Dominica", "alpha-3": "DMA", "country-code": "212" },
  { name: "Dominican Republic", "alpha-3": "DOM", "country-code": "214" },
  { name: "Ecuador", "alpha-3": "ECU", "country-code": "218" },
  { name: "Egypt", "alpha-3": "EGY", "country-code": "818" },
  { name: "El Salvador", "alpha-3": "SLV", "country-code": "222" },
  { name: "Equatorial Guinea", "alpha-3": "GNQ", "country-code": "226" },
  { name: "Eritrea", "alpha-3": "ERI", "country-code": "232" },
  { name: "Estonia", "alpha-3": "EST", "country-code": "233" },
  { name: "Eswatini", "alpha-3": "SWZ", "country-code": "748" },
  { name: "Ethiopia", "alpha-3": "ETH", "country-code": "231" },
  {
    name: "Falkland Islands (Malvinas)",
    "alpha-3": "FLK",
    "country-code": "238",
  },
  { name: "Faroe Islands", "alpha-3": "FRO", "country-code": "234" },
  { name: "Fiji", "alpha-3": "FJI", "country-code": "242" },
  { name: "Finland", "alpha-3": "FIN", "country-code": "246" },
  { name: "France", "alpha-3": "FRA", "country-code": "250" },
  { name: "French Guiana", "alpha-3": "GUF", "country-code": "254" },
  { name: "French Polynesia", "alpha-3": "PYF", "country-code": "258" },
  {
    name: "French Southern Territories",
    "alpha-3": "ATF",
    "country-code": "260",
  },
  { name: "Gabon", "alpha-3": "GAB", "country-code": "266" },
  { name: "Gambia", "alpha-3": "GMB", "country-code": "270" },
  { name: "Georgia", "alpha-3": "GEO", "country-code": "268" },
  { name: "Germany", "alpha-3": "DEU", "country-code": "276" },
  { name: "Ghana", "alpha-3": "GHA", "country-code": "288" },
  { name: "Gibraltar", "alpha-3": "GIB", "country-code": "292" },
  { name: "Greece", "alpha-3": "GRC", "country-code": "300" },
  { name: "Greenland", "alpha-3": "GRL", "country-code": "304" },
  { name: "Grenada", "alpha-3": "GRD", "country-code": "308" },
  { name: "Guadeloupe", "alpha-3": "GLP", "country-code": "312" },
  { name: "Guam", "alpha-3": "GUM", "country-code": "316" },
  { name: "Guatemala", "alpha-3": "GTM", "country-code": "320" },
  { name: "Guernsey", "alpha-3": "GGY", "country-code": "831" },
  { name: "Guinea", "alpha-3": "GIN", "country-code": "324" },
  { name: "Guinea-Bissau", "alpha-3": "GNB", "country-code": "624" },
  { name: "Guyana", "alpha-3": "GUY", "country-code": "328" },
  { name: "Haiti", "alpha-3": "HTI", "country-code": "332" },
  {
    name: "Heard Island and McDonald Islands",
    "alpha-3": "HMD",
    "country-code": "334",
  },
  { name: "Holy See", "alpha-3": "VAT", "country-code": "336" },
  { name: "Honduras", "alpha-3": "HND", "country-code": "340" },
  { name: "Hong Kong", "alpha-3": "HKG", "country-code": "344" },
  { name: "Hungary", "alpha-3": "HUN", "country-code": "348" },
  { name: "Iceland", "alpha-3": "ISL", "country-code": "352" },
  { name: "India", "alpha-3": "IND", "country-code": "356" },
  { name: "Indonesia", "alpha-3": "IDN", "country-code": "360" },
  {
    name: "Iran (Islamic Republic of)",
    "alpha-3": "IRN",
    "country-code": "364",
  },
  { name: "Iraq", "alpha-3": "IRQ", "country-code": "368" },
  { name: "Ireland", "alpha-3": "IRL", "country-code": "372" },
  { name: "Isle of Man", "alpha-3": "IMN", "country-code": "833" },
  { name: "Israel", "alpha-3": "ISR", "country-code": "376" },
  { name: "Italy", "alpha-3": "ITA", "country-code": "380" },
  { name: "Jamaica", "alpha-3": "JAM", "country-code": "388" },
  { name: "Japan", "alpha-3": "JPN", "country-code": "392" },
  { name: "Jersey", "alpha-3": "JEY", "country-code": "832" },
  { name: "Jordan", "alpha-3": "JOR", "country-code": "400" },
  { name: "Kazakhstan", "alpha-3": "KAZ", "country-code": "398" },
  { name: "Kenya", "alpha-3": "KEN", "country-code": "404" },
  { name: "Kiribati", "alpha-3": "KIR", "country-code": "296" },
  {
    name: "Korea (Democratic People's Republic of)",
    "alpha-3": "PRK",
    "country-code": "408",
  },
  { name: "Korea, Republic of", "alpha-3": "KOR", "country-code": "410" },
  { name: "Kuwait", "alpha-3": "KWT", "country-code": "414" },
  { name: "Kyrgyzstan", "alpha-3": "KGZ", "country-code": "417" },
  {
    name: "Lao People's Democratic Republic",
    "alpha-3": "LAO",
    "country-code": "418",
  },
  { name: "Latvia", "alpha-3": "LVA", "country-code": "428" },
  { name: "Lebanon", "alpha-3": "LBN", "country-code": "422" },
  { name: "Lesotho", "alpha-3": "LSO", "country-code": "426" },
  { name: "Liberia", "alpha-3": "LBR", "country-code": "430" },
  { name: "Libya", "alpha-3": "LBY", "country-code": "434" },
  { name: "Liechtenstein", "alpha-3": "LIE", "country-code": "438" },
  { name: "Lithuania", "alpha-3": "LTU", "country-code": "440" },
  { name: "Luxembourg", "alpha-3": "LUX", "country-code": "442" },
  { name: "Macao", "alpha-3": "MAC", "country-code": "446" },
  { name: "Madagascar", "alpha-3": "MDG", "country-code": "450" },
  { name: "Malawi", "alpha-3": "MWI", "country-code": "454" },
  { name: "Malaysia", "alpha-3": "MYS", "country-code": "458" },
  { name: "Maldives", "alpha-3": "MDV", "country-code": "462" },
  { name: "Mali", "alpha-3": "MLI", "country-code": "466" },
  { name: "Malta", "alpha-3": "MLT", "country-code": "470" },
  { name: "Marshall Islands", "alpha-3": "MHL", "country-code": "584" },
  { name: "Martinique", "alpha-3": "MTQ", "country-code": "474" },
  { name: "Mauritania", "alpha-3": "MRT", "country-code": "478" },
  { name: "Mauritius", "alpha-3": "MUS", "country-code": "480" },
  { name: "Mayotte", "alpha-3": "MYT", "country-code": "175" },
  { name: "Mexico", "alpha-3": "MEX", "country-code": "484" },
  {
    name: "Micronesia (Federated States of)",
    "alpha-3": "FSM",
    "country-code": "583",
  },
  { name: "Moldova, Republic of", "alpha-3": "MDA", "country-code": "498" },
  { name: "Monaco", "alpha-3": "MCO", "country-code": "492" },
  { name: "Mongolia", "alpha-3": "MNG", "country-code": "496" },
  { name: "Montenegro", "alpha-3": "MNE", "country-code": "499" },
  { name: "Montserrat", "alpha-3": "MSR", "country-code": "500" },
  { name: "Morocco", "alpha-3": "MAR", "country-code": "504" },
  { name: "Mozambique", "alpha-3": "MOZ", "country-code": "508" },
  { name: "Myanmar", "alpha-3": "MMR", "country-code": "104" },
  { name: "Namibia", "alpha-3": "NAM", "country-code": "516" },
  { name: "Nauru", "alpha-3": "NRU", "country-code": "520" },
  { name: "Nepal", "alpha-3": "NPL", "country-code": "524" },
  { name: "Netherlands", "alpha-3": "NLD", "country-code": "528" },
  { name: "New Caledonia", "alpha-3": "NCL", "country-code": "540" },
  { name: "New Zealand", "alpha-3": "NZL", "country-code": "554" },
  { name: "Nicaragua", "alpha-3": "NIC", "country-code": "558" },
  { name: "Niger", "alpha-3": "NER", "country-code": "562" },
  { name: "Nigeria", "alpha-3": "NGA", "country-code": "566" },
  { name: "Niue", "alpha-3": "NIU", "country-code": "570" },
  { name: "Norfolk Island", "alpha-3": "NFK", "country-code": "574" },
  { name: "North Macedonia", "alpha-3": "MKD", "country-code": "807" },
  { name: "Northern Mariana Islands", "alpha-3": "MNP", "country-code": "580" },
  { name: "Norway", "alpha-3": "NOR", "country-code": "578" },
  { name: "Oman", "alpha-3": "OMN", "country-code": "512" },
  { name: "Pakistan", "alpha-3": "PAK", "country-code": "586" },
  { name: "Palau", "alpha-3": "PLW", "country-code": "585" },
  { name: "Palestine, State of", "alpha-3": "PSE", "country-code": "275" },
  { name: "Panama", "alpha-3": "PAN", "country-code": "591" },
  { name: "Papua New Guinea", "alpha-3": "PNG", "country-code": "598" },
  { name: "Paraguay", "alpha-3": "PRY", "country-code": "600" },
  { name: "Peru", "alpha-3": "PER", "country-code": "604" },
  { name: "Philippines", "alpha-3": "PHL", "country-code": "608" },
  { name: "Pitcairn", "alpha-3": "PCN", "country-code": "612" },
  { name: "Poland", "alpha-3": "POL", "country-code": "616" },
  { name: "Portugal", "alpha-3": "PRT", "country-code": "620" },
  { name: "Puerto Rico", "alpha-3": "PRI", "country-code": "630" },
  { name: "Qatar", "alpha-3": "QAT", "country-code": "634" },
  { name: "Réunion", "alpha-3": "REU", "country-code": "638" },
  { name: "Romania", "alpha-3": "ROU", "country-code": "642" },
  { name: "Russian Federation", "alpha-3": "RUS", "country-code": "643" },
  { name: "Rwanda", "alpha-3": "RWA", "country-code": "646" },
  { name: "Saint Barthélemy", "alpha-3": "BLM", "country-code": "652" },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    "alpha-3": "SHN",
    "country-code": "654",
  },
  { name: "Saint Kitts and Nevis", "alpha-3": "KNA", "country-code": "659" },
  { name: "Saint Lucia", "alpha-3": "LCA", "country-code": "662" },
  {
    name: "Saint Martin (French part)",
    "alpha-3": "MAF",
    "country-code": "663",
  },
  {
    name: "Saint Pierre and Miquelon",
    "alpha-3": "SPM",
    "country-code": "666",
  },
  {
    name: "Saint Vincent and the Grenadines",
    "alpha-3": "VCT",
    "country-code": "670",
  },
  { name: "Samoa", "alpha-3": "WSM", "country-code": "882" },
  { name: "San Marino", "alpha-3": "SMR", "country-code": "674" },
  { name: "Sao Tome and Principe", "alpha-3": "STP", "country-code": "678" },
  { name: "Saudi Arabia", "alpha-3": "SAU", "country-code": "682" },
  { name: "Senegal", "alpha-3": "SEN", "country-code": "686" },
  { name: "Serbia", "alpha-3": "SRB", "country-code": "688" },
  { name: "Seychelles", "alpha-3": "SYC", "country-code": "690" },
  { name: "Sierra Leone", "alpha-3": "SLE", "country-code": "694" },
  { name: "Singapore", "alpha-3": "SGP", "country-code": "702" },
  {
    name: "Sint Maarten (Dutch part)",
    "alpha-3": "SXM",
    "country-code": "534",
  },
  { name: "Slovakia", "alpha-3": "SVK", "country-code": "703" },
  { name: "Slovenia", "alpha-3": "SVN", "country-code": "705" },
  { name: "Solomon Islands", "alpha-3": "SLB", "country-code": "090" },
  { name: "Somalia", "alpha-3": "SOM", "country-code": "706" },
  { name: "South Africa", "alpha-3": "ZAF", "country-code": "710" },
  {
    name: "South Georgia and the South Sandwich Islands",
    "alpha-3": "SGS",
    "country-code": "239",
  },
  { name: "South Sudan", "alpha-3": "SSD", "country-code": "728" },
  { name: "Spain", "alpha-3": "ESP", "country-code": "724" },
  { name: "Sri Lanka", "alpha-3": "LKA", "country-code": "144" },
  { name: "Sudan", "alpha-3": "SDN", "country-code": "729" },
  { name: "Suriname", "alpha-3": "SUR", "country-code": "740" },
  { name: "Svalbard and Jan Mayen", "alpha-3": "SJM", "country-code": "744" },
  { name: "Sweden", "alpha-3": "SWE", "country-code": "752" },
  { name: "Switzerland", "alpha-3": "CHE", "country-code": "756" },
  { name: "Syrian Arab Republic", "alpha-3": "SYR", "country-code": "760" },
  {
    name: "Taiwan, Province of China",
    "alpha-3": "TWN",
    "country-code": "158",
  },
  { name: "Tajikistan", "alpha-3": "TJK", "country-code": "762" },
  {
    name: "Tanzania, United Republic of",
    "alpha-3": "TZA",
    "country-code": "834",
  },
  { name: "Thailand", "alpha-3": "THA", "country-code": "764" },
  { name: "Timor-Leste", "alpha-3": "TLS", "country-code": "626" },
  { name: "Togo", "alpha-3": "TGO", "country-code": "768" },
  { name: "Tokelau", "alpha-3": "TKL", "country-code": "772" },
  { name: "Tonga", "alpha-3": "TON", "country-code": "776" },
  { name: "Trinidad and Tobago", "alpha-3": "TTO", "country-code": "780" },
  { name: "Tunisia", "alpha-3": "TUN", "country-code": "788" },
  { name: "Turkey", "alpha-3": "TUR", "country-code": "792" },
  { name: "Turkmenistan", "alpha-3": "TKM", "country-code": "795" },
  { name: "Turks and Caicos Islands", "alpha-3": "TCA", "country-code": "796" },
  { name: "Tuvalu", "alpha-3": "TUV", "country-code": "798" },
  { name: "Uganda", "alpha-3": "UGA", "country-code": "800" },
  { name: "Ukraine", "alpha-3": "UKR", "country-code": "804" },
  { name: "United Arab Emirates", "alpha-3": "ARE", "country-code": "784" },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    "alpha-3": "GBR",
    "country-code": "826",
  },
  { name: "United States of America", "alpha-3": "USA", "country-code": "840" },
  {
    name: "United States Minor Outlying Islands",
    "alpha-3": "UMI",
    "country-code": "581",
  },
  { name: "Uruguay", "alpha-3": "URY", "country-code": "858" },
  { name: "Uzbekistan", "alpha-3": "UZB", "country-code": "860" },
  { name: "Vanuatu", "alpha-3": "VUT", "country-code": "548" },
  {
    name: "Venezuela (Bolivarian Republic of)",
    "alpha-3": "VEN",
    "country-code": "862",
  },
  { name: "Viet Nam", "alpha-3": "VNM", "country-code": "704" },
  { name: "Virgin Islands (British)", "alpha-3": "VGB", "country-code": "092" },
  { name: "Virgin Islands (U.S.)", "alpha-3": "VIR", "country-code": "850" },
  { name: "Wallis and Futuna", "alpha-3": "WLF", "country-code": "876" },
  { name: "Western Sahara", "alpha-3": "ESH", "country-code": "732" },
  { name: "Yemen", "alpha-3": "YEM", "country-code": "887" },
  { name: "Zambia", "alpha-3": "ZMB", "country-code": "894" },
  { name: "Zimbabwe", "alpha-3": "ZWE", "country-code": "716" },
];
